<template>
    <div class="user-list">
        <div class="table-info">
            <div class="breadcrumb">
            <span>位置：</span>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>用户管理</el-breadcrumb-item>
                <el-breadcrumb-item>用户列表</el-breadcrumb-item>
            </el-breadcrumb>
            </div>
            <h3>用户列表</h3>
        </div>
        <div class="table-content">
            <div class="tool-bar">
                <span>关键字：</span>
                <el-input v-model="keyword" size="small" placeholder="请输入" width="264" class="key-word"></el-input>
                <span>状态：</span>
                <el-select v-model="status" size="small" class="status">
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.title"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button type="primary" size="small" @click="searchUser" v-if="isCompleted && isShowButton('查询')">查询</el-button>
                <el-button size="small" @click="resetData" v-if="isCompleted && isShowButton('重置')">重置</el-button>
                <el-button size="small" type="primary" @click="usergroupModal = true, handleGroup()" v-if="isCompleted && isShowButton('用户分组')">用户分组</el-button>
                <el-button size="small" type="primary" @click="handleOption('新增')" v-if="isCompleted && isShowButton('新增用户')">新增用户</el-button>
            </div>
            <el-table
                :data="tableData5"
                border
                v-loading="loading"
                style="width: 100%">
                <el-table-column
                  label="用户姓名"
                  prop="userName" align="center">
                </el-table-column>
                <el-table-column
                  label="登录名称"
                  prop="loginName" align="center">
                </el-table-column>
                <el-table-column
                  label="性别"
                  width="70"
                  prop="sex" align="center">
                </el-table-column>
                <el-table-column
                  label="所在医院"
                  prop="hospitalName" align="center">
                </el-table-column>
                <el-table-column
                  label="工号"
                  prop="workNum" align="center">
                </el-table-column>
                <el-table-column
                  label="职称"
                  width="70"
                  prop="professionalName" align="center">
                </el-table-column>
                <el-table-column
                  label="病区"
                  width="80"
                  prop="dept" align="center">
                </el-table-column>
                <el-table-column
                  label="电子邮件"
                  width="200"
                  prop="email" align="center">
                </el-table-column>
                <el-table-column
                  label="电话号码"
                  prop="phoneNum" align="center">
                </el-table-column>
               <el-table-column
                 label="所属角色"
                 prop="roleName" align="center">
               </el-table-column>
                <el-table-column
                  label="状态"
                  width="80"
                  align="center">
                  <template slot-scope="scope">
                    <span  v-if="scope.row.status==='正常'" >{{scope.row.status}}</span>
                    <span v-else-if="scope.row.status==='禁用'" :title="scope.row.forbidden">{{scope.row.status}}</span>
                    <span v-else>{{scope.row.status}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="添加时间"
                  prop="createTime" align="center" min-width="170">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="190" align="center">
                  <template slot-scope="scope" v-if="scope.row.status!='删除'">
                      <el-button type="text" @click="handleOption('编辑',scope.row)" v-if="!powers||scope.row.loginName!='admin'">编辑</el-button>
                      <!--<el-button type="text primary" @click="del(scope.row.ID)">删除</el-button>-->
                      <el-popover
                        placement="top"
                        width="172"
                        v-model="scope.row.isAbolish">
                        <p><i class="el-icon-error" style="color:red;"></i>该操作不可逆,是否确认？</p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scope.row.isAbolish = false">取消</el-button>
                          <el-button type="primary" size="mini" @click="scope.row.isAbolish = false,del(scope.row.id)">确定</el-button>
                        </div>
                        <el-button class="marginLeft10" slot="reference" type="text" v-if="!powers||scope.row.loginName!='admin'">删除</el-button>
                      </el-popover>
                      <template v-if="scope.row.status=='正常'">
                        <el-popover
                        placement="top"
                        width="180"
                        v-model="scope.row.isStop">
                        <p>禁用理由</p>
                        <el-input v-model="forbidden" auto-complete="off" size="mini" placeholder="请输入"></el-input>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scope.row.isStop = false">取消</el-button>
                          <el-button type="primary" size="mini" @click="scope.row.isStop = false,disable(scope.row.id)">确定</el-button>
                        </div>
                        <el-button slot="reference" type="text" v-if="!powers||scope.row.loginName!='admin'">禁用</el-button>
                      </el-popover>
                      </template>
                      <template v-if="scope.row.status=='禁用'">
                        <span style="color:#409EFF;cursor:pointer" @click="enable(scope.row.id)" v-if="!powers||scope.row.loginName!='admin'">启用</span>
                      </template>
                  </template>
                </el-table-column>
            </el-table>
          <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page.sync='PageIndex' :page-sizes='[10, 20, 50]'
                         :page-size='PageSize' layout='total, sizes, prev, pager, next, jumper' :total='total'>
          </el-pagination>
        </div>
        <!-- 编辑\新增用户 -->
        <el-dialog :title="title" :visible.sync="dialogShow" :before-close="handleClose">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-row>
                <el-col class="title" :span="3">登录名称：</el-col>
                <el-col :span="9">
                  <el-form-item prop="loginName">
                    <el-input size="mini" v-model="ruleForm.loginName" :disabled="disabled"></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="title" :span="3">真实姓名：</el-col>
                <el-col :span="9">
                  <el-form-item prop="userName">
                    <el-input size="mini" v-model="ruleForm.userName"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="title" :span="3">性别：</el-col>
                <el-col :span="9">
                  <el-form-item prop="sex">
                    <el-radio-group v-model="ruleForm.sex">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col class="title" :span="3">所属角色：</el-col>
                <el-col :span="9">
                  <el-form-item prop="belongRole">
                    <el-select size="mini" v-model="ruleForm.belongRole" placeholder="请选择" @change="ceshi">
                      <el-option v-for="(item,index) in roleList"
                      :key="index"
                      :label="item.itemName"
                      :value="item.itemValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="title" :span="3">登录密码：</el-col>
                <el-col :span="9">
                  <el-form-item v-if="title==='新增用户'" prop="passwords">
                    <el-input size="mini" v-model="ruleForm.passwords"></el-input>
                  </el-form-item>
                  <el-form-item v-else>
                    <el-input size="mini" v-model="ruleForm.passwords"></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="title" :span="3">工号：</el-col>
                <el-col :span="9">
                  <el-form-item prop="workNum">
                    <el-input size="mini" v-model="ruleForm.workNum"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="title" :span="3">病区：</el-col>
                <el-col :span="9">
                  <el-form-item prop="dept">
                    <el-input size="mini" v-model="ruleForm.dept"></el-input>
                  </el-form-item>
                </el-col>
              <el-col class="title" :span="3">所在医院：</el-col>
              <el-col :span="9">
                <el-form-item>
                  <el-select size="mini" :disabled="disabled" v-model="ruleForm.hospitalName" placeholder="请选择">
                    <el-option v-for="item in hospitalList"
                      :key="item.id"
                      :label="item.hospitalName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
                <el-col class="title" :span="3">技术职称：</el-col>
                <el-col :span="9">
                  <el-form-item prop="professionalName">
                    <!-- <el-select size="mini" v-model="ruleForm.technicalTitle"></el-select> -->
                    <el-select size="mini" v-model="ruleForm.professionalName" placeholder="请选择">
                      <el-option v-for="item in technicalTitles"
                      :key="item.value"
                      :label="item.title"
                      :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              <el-col class="title" :span="3">电子邮件：</el-col>
              <el-col :span="9">
                <el-form-item prop="email">
                  <el-input size="mini" v-model="ruleForm.email" :disabled="isEdit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
                <el-col class="title" :span="3">手机号码：</el-col>
                <el-col :span="9">
                  <el-form-item prop="phoneNum">
                    <el-input size="mini" v-model="ruleForm.phoneNum"></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="title" :span="3">岗位：</el-col>
                <el-col :span="9">
                  <el-form-item>
                    <el-select size="mini" v-model="ruleForm.station" placeholder="请选择">
                      <el-option label="医生" :value="0"></el-option>
                      <el-option label="护士" :value="2"></el-option>
                      <el-option label="呼吸治疗师" :value="3"></el-option>
                      <el-option label="其他" :value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
            </el-row>
          </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelDialog('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="handleSubmit('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 用户分组模态框 -->
        <el-dialog title="用户分组" :visible.sync="usergroupModal" class="usergroup">
          <el-row>
            <el-col :span="24">
              <el-table size="mini" height="300" :data="groupData" border style="width: 100%" highlight-current-row>
                <el-table-column
                  prop="groupName"
                  label="分组名称">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isEdit">
                      <el-input size="mini" v-model="scope.row.groupName">
                      </el-input>
                    </span>
                    <span v-if="!scope.row.isEdit">
                      {{scope.row.groupName}}
                    </span>
                  </template>

                </el-table-column>
                <el-table-column
                  prop="coverHospital"
                  label="包含医院">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isEdit">
                      <el-select size="mini" v-model="scope.row.idArr" multiple>
                        <el-option v-for="(item, index) in coverHospitalList" :key="index" :value="item.id" :label="item.hospitalName"></el-option>
                      </el-select>
                    </span>
                    <span v-if="!scope.row.isEdit && scope.row.vArr.length > 3">
                      <div style="height:80px;width:370px;overflow:auto;">
                        {{ scope.row.vArr.join(', ') }}
                      </div>
                    </span>
                    <span v-if="!scope.row.isEdit && scope.row.vArr.length <= 3">
                      <div style="height:80px;width:370px;overflow:auto;line-height:25px;">
                        {{ scope.row.vArr.join(', ') }}
                      </div>
                    </span>
                  </template>

                </el-table-column>
                <el-table-column
                  label="操作"
                  width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isEdit == true">
                      <el-button @click="saveGroup(scope.row)" type="text" size="small">保存</el-button>
                      <el-button v-if="scope.row.id != undefined" type="text" size="small" @click="cancel(scope.row)">取消</el-button>
                    </div>

                    <div v-if="scope.row.isEdit == false">
                      <el-button type="text" size="small" @click="editGroup(scope.row)">编辑</el-button>
                      <el-button type="text" size="small" @click="delGroup(scope.row.id)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="usergroupModal = false">取 消</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
  import { cloneDeep } from 'lodash/Lang'
  import isShowButton from '@/mixins'
  export default {
    mixins: [isShowButton],
  data() {
    const checkEmail = (rule, value, callback) => {
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!value) {
        callback(new Error("请输入电子邮箱"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的电子邮箱"));
      } else {
        callback();
      }
    }
    const checkPhone = (rule, value, callback) => {
      const reg = /^(13[0-9]|19[0-9]|18[0-9]|17[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    }
    return {
      loading: true,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,


      // 用户分组
      groupToCache: '',
      coverHospitalList: [{
        id: 1,
        hospitalName: '华西医院'
      }],
      groupPageIndex: 1,
      groupPageSize: 10,
      groupData: [{
        groupName: '',
        idArr: [],
        vArr: [],
        coverHospital: [],
        isEdit: true
      }],
      isEdit: false, //控制邮箱是否可修改
      usergroupModal: false,
      powers:true,
      disabled:false,
      forbidden:'',//禁用原因
      keyword:'',
      PageIndex:1, //当前页
      PageSize:10, //每页数量
      totalCache:0, //条数
      title:'',
      status: "",
      statusList:[
        {title:'启用',value:1},
        {title:'禁用',value:2},
      ],
      roleList:[], //角色列表
      hospitalList:[], //医院列表
      // 新增用户表单
      dialogShow: false,
      technicalTitles:[
        {title:'高级',value:1},
        {title:'副高',value:2},
        {title:'中级',value:3},
        {title:'初级',value:4},
        {title:'其他',value:5}
      ],
      initForm:{
        id:'',
        dept:'',
        email:'',
        hospitalName:'',
        loginName:'',
        phoneNum:'',
        professionalName:'',
        sex:'',
        status:'',
        userName:'',
        workNum:'',
        createTime:'',
        belongRole:'',
        passwords:'',
        station: ''
      },
      ruleForm: {},
      // 编辑用户表单
      rules: {
        loginName:[{ required: true, message: "请输入登录名称", trigger: "blur" },{max:20,message:'不能超过20个字符'}],
        userName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },{max:20,message:'不能超过20个字符'}
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        belongRole: [
          { required: true, message: "请选择所属角色", trigger: "blur" }
        ],
        passwords: [
          { required: true, message: "请输入登录密码", trigger: "blur" },{max:10,message:'初始密码不能超过10位'}
        ],
        hospitalName: [
           { required: true, message: "请选择医院", trigger: "blur" }
         ],
        workNum: [{ required: true, message: "请输入工号", trigger: "blur" },{max:20,message:'不能超过20个字符'}],
        dept: [{ required: true, message: "请输入病区", trigger: "blur" },{max:20,message:'不能超过20个字符'}],
        professionalName: [
          { required: true, message: "请选择技术职称", trigger: "blur" }
        ],
        email: [{ validator: checkEmail, trigger: "blur" }],
        phoneNum: [{ validator: checkPhone, trigger: "blur" }]
      },
      tableData5: [], //列表数据
      // hospitalList: ''
    };
  },
  methods: {
    // 点击用户分组
    handleGroup() {
      this.getAllGroup(1, 10)
    },
    // 获取所有医院
    getAllHospitall() {
      this.Axios.get('/api/Hospital/GetAllHospitals').then(res => {
        const data = res.data
        if (data.status === 100) {
          this.coverHospitalList = data.data
        }
      })
    },
    addRow() {
    },
    // 保存分组
    saveGroup(val) {
      // console.log(val)
      let formData = {
        groupName: val.groupName,
        coverHospital: val.idArr
      }
      if (val.id == undefined) {
        this.Axios.post('/api/GroupHospital/AddGroupHospital', formData).then(res => {
          // console.log(res.data)
          const data = res.data
          if (data.status === 100) {
            this.$message({
              showClose: true,
              message: '添加成功!',
              type: 'success'
            })
            this.getAllGroup(1, 10)
            this.groupData[0].groupName = ''
            this.groupData[0].coverHospital = ''
          } else {
            this.$message({
              showClose: true,
              message: '添加失败!',
              type: 'error'
            })
          }
        })
      } else {
          this.Axios.put('/api/GroupHospital/UpdateGroupHospital?id=' + val.id, formData).then(res => {
            // console.log(res.data)
            const data = res.data
            if (data.status === 100) {
              this.$message({
                showClose: true,
                message: '修改成功!',
                type: 'success'
              })
              this.getAllGroup(1, 10)
              // this.groupData[0].groupName = ''
              // this.groupData[0].coverHospital = ''
            } else {
              this.$message({
                showClose: true,
                message: '修改失败!',
                type: 'error'
              })
            }
          })
        }
    },
    // 查询所有分组
    getAllGroup(pageindex, pagesize) {
      this.Axios.get('/api/GroupHospital/GetGroupHospitalList?pageindex=' + pageindex + '&pagesize=' + pagesize).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status === 100) {
          this.groupData = [{
            groupName: '',
            idArr: [],
            coverHospital: [],
            isEdit: true
          }]
          for (let item of data.data) {
            item.isEdit = false
            let idArr = []
            let vArr = []
            for (let hItem of item.coverHospital) {
              idArr.push(hItem.id)
              vArr.push(hItem.hospitalName)
            }
            item.idArr = idArr
            item.vArr = vArr

            this.groupData.push(item)
          }
          // console.log('分组', this.groupData)
        } else {
          this.$message({
            showClose: true,
            message: '请求失败,请重新刷新!',
            type: 'error'
          })
        }
      })
    },
    // 删除医院分组
    delGroup(id) {
      // console.log(id)
      this.Axios.delete('/api/GroupHospital/DeleteGroupHospital?groupId=' + id).then(res => {
        const data = res.data
        if (data.status === 100) {
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success'
          })
          this.getAllGroup(1, 10)
        } else {
          this.$message({
            showClose: true,
            message: '删除失败!',
            type: 'error'
          })
        }
      })
    },
    editGroup(row) {
      this.$set(row, 'isEdit', true)
    },
    cancel(row) {
      this.$set(row, 'isEdit', false)
    },
    groupSizeChange(pagesize) {

    },
    groupCurrentChange(pageindex) {

    },
    handleClose(done){
      this.$confirm('关闭后信息不能保存,是否退出？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    ceshi(value){
    },
    resetData(){
      this.status=''
      this.keyword=''
      this.searchUser();
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.searchUser()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.searchUser()
    },
    //新增、编辑操作
    handleOption(option,val){
      this.ruleForm={}
      if(option==='新增'){
        this.isEdit = false
        this.disabled=false
        this.title='新增用户'
        this.dialogShow=true
        this.ruleForm=this.initForm
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields()
        })
      }else if(option==='编辑'){
        this.disabled=true
        this.title='编辑用户'
        this.dialogShow=true
        this.ruleForm=cloneDeep(val)
        this.Axios.get("/api/User/GetUserInfo/"+val.id).then(res=>{
          if(res.status === 200){
            // console.log('编辑用户', res.data)
            this.ruleForm.dept = res.data.dept
            this.ruleForm.email = res.data.email
            this.ruleForm.hospitalName = res.data.hospital
            this.ruleForm.id = res.data.id
            this.ruleForm.loginName = res.data.loginName
            this.ruleForm.phoneNum = res.data.phoneNum
            this.ruleForm.professionalName = res.data.professional
            this.ruleForm.sex = res.data.sex
            this.ruleForm.userName = res.data.userName
            this.ruleForm.workNum = res.data.workNum
            this.$set(this.ruleForm, 'belongRole', res.data.belongRole)
            this.$set(this.ruleForm, 'passwords', '')
            // this.ruleForm.BelongRole=res.data.BelongRole
            // this.ruleForm.passwords=null
            if (res.data.zcode != '' || res.data.zcode != null) {
              this.isEdit = true
            }
          }
        })
      }
    },
    // 新增,编辑用户表单
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.title==='新增用户'){
            const data={
              loginName:this.ruleForm.loginName,
              userName:this.ruleForm.userName,
              sex:this.ruleForm.sex,
              belongRole:this.ruleForm.belongRole,
              passwords:this.ruleForm.passwords.trim(),
              workNum:this.ruleForm.workNum,
              dept:this.ruleForm.dept,
              hospital:this.ruleForm.hospitalName,
              professional:this.ruleForm.professionalName,
              email:this.ruleForm.email,
              phoneNum:this.ruleForm.phoneNum,
              station: this.ruleForm.station
            }
            this.Axios.post('/api/User/AddUser',data).then(res=>{
              // console.log("aa",res)
              if(res.data.status === 100){
                this.$message({
                  showClose: true,
                  message: '新增成功',
                  type: 'success'
                });
                this.$refs[formName].resetFields();
                this.dialogShow = false
                this.searchUser()
              }else{
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: 'error'
                });
              }
            }).catch(err=>{
              this.$message({
                showClose: true,
                message: '网络错误，联系管理员',
                type: 'error'
              });
            })
          }else if(this.title==='编辑用户'){
            const data={
              loginName:this.ruleForm.loginName,
              userName:this.ruleForm.userName,
              sex:this.ruleForm.sex,
              belongRole:this.ruleForm.belongRole,
              passwords:this.ruleForm.passwords,
              workNum:this.ruleForm.workNum,
              dept:this.ruleForm.dept,
              hospital:this.ruleForm.hospitalName,
              professional:this.ruleForm.professionalName,
              email:this.ruleForm.email,
              phoneNum:this.ruleForm.phoneNum,
              station: this.ruleForm.station
            }
            this.Axios.put('/api/User/UpdateUser/'+this.ruleForm.id, data).then(res=>{
              if(res.data.status){
                this.$message({
                  showClose: true,
                  message: '修改成功',
                  type: 'success'
                });
                this.dialogShow = false
              }
              this.searchUser()
            }).catch(err=>{
              this.$message({
                showClose: true,
                message: '网络错误，联系管理员',
                type: 'error'
              });
            })
            this.$refs[formName].resetFields();
          }
        } else {
          // console.log("errorsubmit");
          return false;
        }
      });
    },
    // 关闭dialog
    cancelDialog(formName) {
      this.dialogShow = false
      if (this.title === '新增用户') {
        this.$refs[formName].resetFields()
      }
    },
    // 获取所有用户
    searchUser(){
      const conditions={
        pagesize:this.PageSize,
        start:this.PageIndex
      }
      if(this.keyword!=''){
        conditions.keyword=this.keyword
      }
      if(this.status!=''){
        conditions.status=this.status
      }
      this.loading = true
      this.Axios.get("/api/User/SearchUser",{params:conditions}).then(res=>{
        if(res.status === 200){
          this.tableData5=res.data.data
          this.totalCache=res.data.total
          this.loading = false
        }
      }).catch(err=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    GetRoleList(){
      this.Axios.post('/api/Role/GetRoleList').then(res=>{
        // console.log('用户角色', res)
        if(res.status===200){
          this.roleList=res.data
        }
      }).catch(err=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    GetHospitalList(){
      this.Axios.get("/api/Hospital/GetAllHospitalByRole").then(res=>{
        if(res.data.status===100){
          this.hospitalList = res.data.data
          // hospitalName id
        }
      }).catch(err=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    //删除
    del(id){
        this.Axios.delete('/api/User/DeleteUser/'+id).then((res)=>{
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success'
          })
          this.searchUser()
        }).catch(err=>{
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          });
        })
    },
    // 禁用
    disable(id) {
      this.Axios.put("/api/User/ForbiddenUser/"+id+","+this.forbidden).then(res=>{
        if(res.data.status){
          this.$message({
            showClose: true,
            message: '禁用成功',
            type: 'success'
          });
          this.searchUser()
        }else{
          this.$message({
            showClose: true,
            message: '禁用失败',
            type: 'error'
          });
        }
      }).catch(err=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    // 启用
    enable(id) {
      this.Axios.put('/api/User/ChristenUser/'+id).then(res=>{
        if(res.data.status){
          this.$message({
            showClose: true,
            message: '启用成功',
            type: 'success'
          });
          this.searchUser()
        }else{
          this.$message({
            showClose: true,
            message: '启用失败',
            type: 'error'
          });
        }
      }).catch(err=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },

  },
  computed: {
    total() {
      return this.totalCache
    }
  },
  created(){
    this.getBtnRole()
    this.searchUser()
    this.GetRoleList()
    this.GetHospitalList()
    this.getAllHospitall()
    if(localStorage.getItem('LoginName')==='admin'){
      this.powers=false
    }
  }
};
</script>

<style scoped lang="less">
.user-list {
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .el-table {
      margin: 20px 0;
      .marginRight10 {
        margin-right: 10px;
      }
    }
    .el-pagination {
      /deep/ .number,
      /deep/ .btn-prev,
      /deep/ .btn-next {
        background-color: #fff;
        border: 1px solid #d9d9d9;
        width: 32px;
        height: 32px;
      }
    }
  }
  .el-dialog__wrapper {
    .el-row {
      padding: 15px;
      .title {
        text-align: right;
        padding-top: 10px;
      }
    }
    .el-input,
    .el-select {
      width: 206px;
    }
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
  }
  // 用户分组输入框
  .usergroup {
    /deep/ .el-input__inner {
      // width: 300px;
    }
  }
  .el-table-add-row {
    margin-top: 10px;
    width: 100%;
    height: 34px;
    border: 1px dashed #c1c1cd;
    border-radius: 3px;
    cursor: pointer;
    justify-content: center;
    display: flex;
    line-height: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/UserManage/UserList.vue